export default __webpack_public_path__ + "static/media/user-not-found.6c59b2b4.svg";